// Typed wrapper around /api/v1/admin/units. Powers the unit-picker on the
// invoice create form. Phase 5c will replace this with a full units browser.

import type {
  AdminUnit,
  CreateAdminUnitRequest,
  UpdateAdminUnitRequest,
} from '@residenone/shared';
import { api } from './api-client';
import { labelRepeatsAddress, unitAddress } from './unit-address';

export type { AdminUnit, CreateAdminUnitRequest, UpdateAdminUnitRequest };

export async function listAdminUnits(): Promise<AdminUnit[]> {
  const { data } = await api.get<{ units: AdminUnit[] }>('/admin/units');
  return data.units;
}

export async function createUnit(body: CreateAdminUnitRequest): Promise<AdminUnit> {
  const { data } = await api.post<{ unit: AdminUnit }>('/admin/units', body);
  return data.unit;
}

export async function updateUnit(
  id: string,
  body: UpdateAdminUnitRequest,
): Promise<AdminUnit> {
  const { data } = await api.patch<{ unit: AdminUnit }>(`/admin/units/${id}`, body);
  return data.unit;
}

export async function deleteUnit(id: string): Promise<void> {
  await api.delete(`/admin/units/${id}`);
}

/** "A No. 12 (Mawar 12)": the address, plus the label when it says more. */
export function formatUnitOption(u: AdminUnit): string {
  return `${unitAddress(u.block, u.number)}${labelRepeatsAddress(u.label, u.block, u.number) ? '' : ` (${u.label})`}`;
}
